import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Jacob T. Weinrich</h3>
            <p>Software Developer</p>
            <p>Just outside St. Louis, Missouri</p>
            <p>Central Standard Time</p>
          </div>
          
          <div className="footer-section">
            <h4>Contact</h4>
            <p>Email: <a href="mailto:JacobW@segotw.com">JacobW@segotw.com</a></p>
            <p>Phone: <a href="tel:+13149399335">(314) 939-9335</a></p>
            <p>LinkedIn: <a href="https://www.linkedin.com/in/jacob-weinrich/" target="_blank" rel="noopener noreferrer">@jacob-weinrich</a></p>
            <p>GitHub: <a href="https://github.com/JacobWeinrich" target="_blank" rel="noopener noreferrer">github.com/JacobWeinrich</a></p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/about">About</a></li>
              <li><a href="/projects">Projects</a></li>
              <li><a href="/skills">Skills</a></li>
              <li><a href="/experience">Experience</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Jacob Weinrich. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 